import { BehaviorTracker } from '@randyd45/web-behavior-tracker';

class BehaviorTrackerService {
    #behaviorTracker;

    constructor() {
        this.#behaviorTracker = new BehaviorTracker({
            trackMouseMovements: false,
            trackFocusBlur: true,
            trackInputChanges: true,
            trackClicks: false,
            riskThreshold: 0.7,
            minTimeSpent: 10000,
            maxTimeSpent: 600000
        });
    }

    startTracking() {
        try {
            this.#behaviorTracker.startTracking();
        } catch (error) {
            console.error("Error starting tracking:", error);
            throw error;
        }
    }

    stopTracking() {
        try {
            this.#behaviorTracker.stopTracking();
        } catch (error) {
            console.error("Error stopping tracking:", error);
            throw error;
        }
    }

    getTrackingData() {
        try {
            return {
                events: this.#behaviorTracker.getEvents(),
                insights: this.#behaviorTracker.getInsights(),
                stats: this.#behaviorTracker.getMetrics(),
                sessionId: this.#behaviorTracker.getSessionId(),
            };
        } catch (error) {
            console.error("Error getting tracking data:", error);
            throw error;
        }
    }
}

export default new BehaviorTrackerService();
